import { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { obtenerConfiguracionDet } from '../../services/Configuracion/ConfiguracionDetService';
import { ESTADO_CREADO_CODE } from './data/custodiaDicctionary';

const TIPO_INTEGRANTES_CAB_CODE = 'CUS-0000-0001';

export const IntegrantesCrud = ({ patrullaSelected, onClose, onSuccesSave, estadoCustodia, onlyRead }) => {
    const [integrantesTipo, setIntegrantesTipo] = useState([]);
    const [integranteFormulario, setIntegranteFormulario] = useState({
        tipo: null,
        nombre: ''
    });
    const [integrantesList, setIntegrantesList] = useState([]);

    useEffect(() => {
        // Simular la carga de tipos de integrantes desde una API o fuente de datos
        if (patrullaSelected?.integrantes) {
            setIntegrantesList(patrullaSelected.integrantes);
        } else {
            setIntegrantesList([]);
        }
    }, [patrullaSelected]);

    const cargarTiposIntegrantes = async () => {
        try {
            const response = await obtenerConfiguracionDet(TIPO_INTEGRANTES_CAB_CODE);
            setIntegrantesTipo(response.map((item) => ({ id: item.configuracionDetId, nombre: item.nombre })));
        } catch (error) {
            console.error('Error loading estado custodia:', error);
        }
    };

    useEffect(() => {
        cargarTiposIntegrantes();
    }, []);

    const handleGuardarIntegrante = () => {
        if (integranteFormulario.tipo && integranteFormulario.nombre) {
            const nuevoIntegrante = {
                id: integranteFormulario.id || `temp-${Date.now()}`,
                tipo: integranteFormulario.tipo,
                nombre: integranteFormulario.nombre
            };

            // Si el integrante ya existe, actualizamos la información
            const existenteIndex = integrantesList.findIndex((integrante) => integrante.id === nuevoIntegrante.id);
            if (existenteIndex !== -1) {
                const updatedList = [...integrantesList];
                updatedList[existenteIndex] = nuevoIntegrante;
                setIntegrantesList(updatedList);
            } else {
                setIntegrantesList([...integrantesList, nuevoIntegrante]);
            }
            setIntegranteFormulario({});
        }
    };

    const onSave = () => {
        onSuccesSave(patrullaSelected.id, integrantesList);
    };

    const diaglogFooter = (
        <div>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-secondary" onClick={onClose} />
            <Button label="Guardar" icon="pi pi-check" className="p-button-success" onClick={onSave} disabled={estadoCustodia !== ESTADO_CREADO_CODE || onlyRead} />
        </div>
    );

    const onDeleteIntegrante = (rowData) => {
        setIntegrantesList(integrantesList.filter((integrante) => integrante.id !== rowData.id));
        setIntegranteFormulario({});
    };

    const onStartEdit = (rowData) => {
        setIntegranteFormulario({
            id: rowData.id,
            tipo: rowData.tipo,
            nombre: rowData.nombre
        });
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-danger"
                    tooltip="Eliminar"
                    onClick={() => {
                        onDeleteIntegrante(rowData);
                    }}
                    disabled={estadoCustodia !== ESTADO_CREADO_CODE || onlyRead}
                />
                <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-info ml-2"
                    tooltip="Editar"
                    onClick={() => {
                        onStartEdit(rowData);
                    }}
                    disabled={estadoCustodia !== ESTADO_CREADO_CODE || onlyRead}
                />
            </>
        );
    };

    return (
        <Dialog visible={patrullaSelected !== null} closable={false} onHide={onClose} className="w-full md:w-8 lg:w-6" header={`Integrantes de la patrulla `} footer={diaglogFooter}>
            <div className="grid flex flex-column md:flex-row lg:flex-row sm:flex-row">
                <div className="field col">
                    <label htmlFor="clienteList">Tipo </label>
                    <div className="p-inputgroup">
                        <Dropdown
                            id="tipoList"
                            options={integrantesTipo}
                            optionValue="id"
                            optionLabel="nombre"
                            value={integranteFormulario.tipo}
                            onChange={(e) => setIntegranteFormulario({ ...integranteFormulario, tipo: e.value })}
                            placeholder="Selecciona el tipo"
                            filter
                            className="w-full md:w-14rem"
                            disabled={estadoCustodia !== ESTADO_CREADO_CODE || onlyRead}
                        />
                    </div>
                    <div className="field col">
                        <label htmlFor="nombre">Nombre</label>
                        <div className="p-inputgroup">
                            <InputText
                                id="nombre"
                                placeholder="Ingresa el nombre"
                                className="w-full md:w-14rem"
                                value={integranteFormulario.nombre || ''}
                                onChange={(e) => setIntegranteFormulario({ ...integranteFormulario, nombre: e.target.value })}
                                disabled={estadoCustodia !== ESTADO_CREADO_CODE || onlyRead}
                            />
                        </div>
                    </div>
                    <div className="field col-12 md:col-3 flex align-items-end">
                        <Button icon="pi pi-save" className="p-button-success" tooltip="Guardar" onClick={handleGuardarIntegrante} disabled={estadoCustodia !== ESTADO_CREADO_CODE || onlyRead} />
                        <Button icon="pi pi-times" className="p-button-secondary ml-2" tooltip="Limpiar" onClick={() => setIntegranteFormulario({})} disabled={estadoCustodia !== ESTADO_CREADO_CODE} />
                    </div>
                </div>
            </div>
            <div className="col-12">
                <h5>Lista de Integrantes</h5>
                <DataTable value={integrantesList} paginator rows={5} rowsPerPageOptions={[5, 10]} scrollable scrollHeight="300px" dataKey="id" responsiveLayout="scroll">
                    <Column header="Tipo" sortable body={(rowData) => integrantesTipo.find((tipo) => tipo.id === rowData.tipo)?.nombre}></Column>
                    <Column field="nombre" header="Nombre" sortable></Column>
                    <Column header="Acciones" body={actionBodyTemplate}></Column>
                </DataTable>
            </div>
        </Dialog>
    );
};
